import EventCalendar from "./EventCalendar";
import { createBookingEventDraft } from "./BookingEventUtils";
import { db } from "../../../firebase";
import { doc, updateDoc } from "firebase/firestore";
import { notifyError, notifyTopRight } from "../toast/SetToast";

// Use the calendar's event dialog and file handlers while the table owns
// booking queries, access filtering, and pagination. No calendar is mounted.
class BookingEventModal extends EventCalendar {
  static defaultProps = { modalOnly: true };

  constructor(props) {
    super(props);
    this.state = { ...this.state, ...props.lookupData };

    const updateReportReadiness = this.updateCalendarReportReadiness;
    this.updateCalendarReportReadiness = (event, reports = [], invalidate = true) => {
      updateReportReadiness(event, reports, invalidate);
      const hn = String((event.extendedProps || {}).hn || "").trim();
      if (this._isMounted && hn && this.props.onReportsChange) {
        this.props.onReportsChange(hn, this.cloneBookingReportRows(reports));
      }
    };

    const saveCalendarEvent = this.onEditEvent;
    this.onEditEvent = () => {
      // Keep the table's existing full-time technician write scope.
      if (
        this.getCurrentUserRoles().includes("sleep_technician") &&
        !this.isCurrentUserPartTimeSleepTechnician() &&
        this.state.isEditBookingDetail
      ) {
        return this.saveFullTimeTechnicianSale();
      }
      return saveCalendarEvent();
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.state.nodeIdDocs.forEach((nodeId, index) => {
      this.customerCache[nodeId] = this.state.customerAllList[index] || [];
    });

    const booking = this.cloneCalendarEvents([this.props.booking])[0];
    booking.extendedProps.reports = this.cloneBookingReportRows(
      booking.reports || booking.extendedProps.reports || [],
    );
    this.eventClick({ event: createBookingEventDraft(booking) });
  }

  componentDidUpdate(_previousProps, previousState) {
    if (previousState.isEditEventModal && !this.state.isEditEventModal) {
      this.props.onClose();
    }
  }

  componentWillUnmount() {
    this.eventClickRequestId = (this.eventClickRequestId || 0) + 1;
    this.customerRequestId = (this.customerRequestId || 0) + 1;
    super.componentWillUnmount();
  }

  syncCalendarEventState = (event, oldEvent, selectedDate) => {
    if (this.props.onSaved) {
      this.props.onSaved(this.eventApiToCalendarEvent(event, selectedDate), oldEvent);
    }
  };

  removeCalendarEventState = (event) => {
    if (this.props.onRemoved) this.props.onRemoved(event);
  };

  saveFullTimeTechnicianSale = async () => {
    const event = this.state.eventTmp;
    const eventProps = event.extendedProps || {};
    const nodeId = this.state.nodeIdDocs[this.state.nodeList.indexOf(eventProps.node)];
    if (!nodeId || !eventProps.uuid) {
      notifyError("Cannot update this booking because its calendar record was not found.");
      return;
    }

    try {
      const selectedSale = this.getBookingSaleValueForSave(eventProps.sale);
      await updateDoc(doc(db, "nodes", nodeId, "bookings", eventProps.uuid), {
        "extendedProps.sale": selectedSale,
      });
      // Other form values remain read-only for full-time technicians.
      const savedEvent = createBookingEventDraft(this.editingEventSnapshot);
      savedEvent.setExtendedProp("sale", selectedSale);
      this.syncCalendarEventState(savedEvent, this.editingEventSnapshot);
      this.setState({ isEditBookingDetail: false, isEditEventModal: false });
      notifyTopRight("Booking updated");
    } catch (error) {
      console.error("Unable to update booking salesperson", error);
      notifyError("Unable to update booking.");
    }
  };
}

export default BookingEventModal;
